export default __webpack_public_path__ + "static/media/pictogramCards64.b568e664.svg";